module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAASCAMAAACzQHQ9AAAAP1BMVEVMaXF/hJR/hJR/h5d/g5N/g5R/gpN/hJN/gpJ8gpJ/g5OAhJR/g5N/g5OAg5KAg5J+g5KJiZJ/gpSAhJOAhJTHFrvuAAAAFHRSTlMAjmAgP7rgcLAvgvGnwFeXZQ5KeZAKHUoAAAB3SURBVHjajdDLDsMwCERRcIzB7ySd///WYjmVusxdIJ3dCCIS/Oq0AuuuYDvT7nhjM3TbCcwIqAwINzQWwD2zIZTBuUVZjjIQpnLu93K6wlXDPZHPBncpKbRgQE5YThU1+YHTrfq3V/XN3jPuxuPVB962wJPnH18n3wmm3ehWAAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/icon-app.png
// module id = o2Bm
// module chunks = 0